import type { IRecordStats, IRecordTypeDefinition } from '@platform/core/types';

/** Поле рівня ризику та його значення «Критичний» / «Високий» (прототип v4: поради модуля Ризики — r.v.level). */
const LEVEL = 'level';
const CRITICAL = 'Critical';
const HIGH = 'High';
/** Поле стратегії реагування та значення «Прийняття» (r.v.strategy === 'Accept'). */
const STRATEGY = 'strategy';
const ACCEPT = 'Accept';

/** Фільтр-DSL статистики відкритих критичних ризиків (`by=status`) і прийнятих ризиків (`by=level`). */
export const criticalFilter = `${LEVEL}:eq:${CRITICAL}`;
export const acceptedFilter = `${STRATEGY}:eq:${ACCEPT}`;
export const levelField = LEVEL;

/** Реєстр ризиків: тип запису має вибір рівня з «Критичний» і «Високий» та вибір стратегії з «Прийняття» (поради ризиків прототипу). */
export function isRiskRegister(rt: IRecordTypeDefinition): boolean {
  const has = (key: string, values: string[]) => {
    const options = rt.fields.find((f) => f.key === key)?.options?.map((o) => o.value) ?? [];
    return values.every((v) => options.includes(v));
  };
  return has(LEVEL, [CRITICAL, HIGH]) && has(STRATEGY, [ACCEPT]);
}

/** Кількість критичних ризиків у незакритих статусах (статистика `by=status` з фільтром критичного рівня). */
export function openCriticalOf(stats: IRecordStats | undefined, closed: ReadonlySet<string>): number | undefined {
  return stats ? stats.buckets.filter((b) => b.value !== null && !closed.has(b.value)).reduce((n, b) => n + b.count, 0) : undefined;
}

/** Кількість критичних і високих ризиків серед прийнятих (статистика `by=level` з фільтром стратегії «Прийняття»). */
export function acceptedHighOf(stats: IRecordStats | undefined): number | undefined {
  return stats ? stats.buckets.filter((b) => b.value === CRITICAL || b.value === HIGH).reduce((n, b) => n + b.count, 0) : undefined;
}
